(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('SMSService', SMSService);

  SMSService.$inject = ['$resource'];

	 function SMSService ($resource) {
    return $resource(apiUrl + '/sms/:id', { id: '@id' }, {
      all: { method: 'GET', params: {}, isArray: true },
      create: { method: 'POST', params: {}, isArray: false },
      update: { method: 'POST', params: { _method: 'PATCH' }, isArray: false },
      find: { method: 'GET', params: {}, isArray: false },
      findOne: { method: 'GET', params: {}, isArray: true },
      setPGReturn: { url: apiUrl + '/sms-set-pg', method: 'POST', params: {}, isArray: false },
      getAllChannels: { url: apiUrl + '/sms-get-channels', method: 'GET', isArray: true },
      sms_message_status: { url: apiUrl + '/sms/message-status', method: 'GET', isArray: false },
      createActiveSms: { url: apiUrl + '/create-active-sms', method: 'POST', params: {}, isArray: false }
    });
  }
})();
